import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { blue } from '@material-ui/core/colors';

export default getMuiTheme({
  palette: {
    primary1Color: blue[500],
  },
});
